import axios from "axios";
import {
    AdminTransportBookingReadDto,
    AdminTransportBookingTotalsDto,
    DriverPersonReadDto,
    TransportVehicleReadDto,
    AssignTransportBookingDto,
    OptionTransportTypeDto,
    OptionTransportStatusDto,
    AdminTransportLocationDto,
    AdminTransportTimeWindowDto,
    UpdateTransportRequestAdminDto,
    FlightStatusDto
} from "../Pages/Transport/types";

const apiUrl = process.env.REACT_APP_API_URL as string;

export async function getAdminBookings(
    eventId: number,
    filters?: {
        kind?: number | null;
        statusId?: number | null;
        from?: string | null;
        to?: string | null;
        q?: string | null;
    }
) {
    const res = await axios.get(
        `${apiUrl}/api/events/${eventId}/transport/admin/requests`,
        {
            params: {
                kind: filters?.kind ?? undefined,
                statusId: filters?.statusId ?? undefined,
                from: filters?.from ?? undefined,
                to: filters?.to ?? undefined,
                q: filters?.q ?? undefined,
            },
        }
    );
    return res.data;
}

export async function getAdminTotals(eventId: number) {
    const res = await axios.get<AdminTransportBookingTotalsDto[]>(
        `${apiUrl}/api/events/${eventId}/transport/admin/requests/totals`
    );
    return res.data;
}


export async function getDriversForEvent(eventId: number, date?: string | null) {
    const res = await axios.get<DriverPersonReadDto[]>(
        `${apiUrl}/api/drivers/by-event/${eventId}`,
        {
            params: {
                date: date ?? undefined,
            },
        }
    );

    return res.data;
}

export async function getVehicles(eventId: number) {
    const res = await axios.get<TransportVehicleReadDto[]>(
        `${apiUrl}/api/transport/admin/vehicles`,
        { params: { eventId, activeOnly: false } }
    );
    return res.data;
}

export async function assignBooking(requestId: number, dto: AssignTransportBookingDto) {
    const payload = {
        driverId: dto.driverPersonId ?? null,
        vehicleId: dto.vehicleId ?? null,
        note: dto.note ?? null,
        statusTransportId: dto.statusTransportId ?? null,
        plannedPickupAt: dto.plannedPickupAt ?? null,
    };

    await axios.patch(`${apiUrl}/api/transport/admin/requests/${requestId}/assign`, payload);
}


export async function getLocations(eventId: number): Promise<AdminTransportLocationDto[]> {
    const res = await axios.get<AdminTransportLocationDto[]>(
        `${apiUrl}/api/transport/admin/locations`,
        { params: { eventId } }
    );
    return res.data;
}

export async function getTimeWindows(eventId: number) {
    const res = await axios.get<AdminTransportTimeWindowDto[]>(
        `${apiUrl}/api/transport/admin/timewindows`,
        { params: { eventId } }
    );
    return res.data;
}

export async function getTransportStatusOptions() {
    const res = await axios.get<OptionTransportStatusDto[]>(
        `${apiUrl}/api/Option_TransportStatus`
    );
    return res.data;
}

export async function getTransportTypeOptions() {
    const res = await axios.get<OptionTransportTypeDto[]>(
        `${apiUrl}/api/Option_TransportType`
    );
    return res.data;
}

export async function updateRequestAdmin(requestId: number, dto: Partial<UpdateTransportRequestAdminDto>) {
        const res = await axios.patch(`${apiUrl}/api/transport/admin/requests/${requestId}`, dto);
        return res.data;
}   

export async function getTransportRequestMessages(requestId: number) {
    const res = await axios.get(`${apiUrl}/api/whatsapp/transport-request/${requestId}`);
    return res.data;
}

export async function markTransportRequestMessagesRead(requestId: number) {
    await axios.post(`${apiUrl}/api/whatsapp/transport-request/${requestId}/mark-read`);
}

export async function sendTransportRequestMessage(requestId: number, message: string) {
    await axios.post(`${apiUrl}/api/whatsapp/transport-request/${requestId}/send`, {
        message,
    });
}

export async function attachMessageToTransportRequest(messageId: number, requestId: number) {
    await axios.post(
        `${apiUrl}/api/whatsapp/messages/${messageId}/attach-transport-request/${requestId}`
    );
}


export async function checkFlightStatus(eventId: number, bookingId: number) {
    const res = await axios.get<FlightStatusDto>(
        `${apiUrl}/api/${eventId}/bookings/${bookingId}/flight-status`
    );
    return res.data;
}

export async function deleteRequestAdmin(bookingId: number) {
    const res = await axios.delete(`${apiUrl}/api/transport/admin/requests/${bookingId}`);
    return res.data;
}

export async function getDriverLog(requestId: number) {
    const res = await fetch(
        `${apiUrl}/api/v2/driver-requests/transport/driver/requests/${requestId}/log`
    );

    if (!res.ok) return null;

    const text = await res.text();
    if (!text) return null;

    return JSON.parse(text);
}
